const EXERCISES_UI_KEY = {
  QUERY: 'query',
  FILTERS: 'filters',
  TYPE_FILTER: 'typeFilter',
  EQUIPMENT_FILTER: 'equipmentFilter',
  MUSCLE_FILTER: 'muscleFilter',
  PAGE: 'page'
}

const EXERCISES_UI_FILTERS_KEY = {
  TYPES: 'types',
  MUSCLES: 'muscles',
  EQUIPMENT: 'equipment'
}

export { EXERCISES_UI_KEY, EXERCISES_UI_FILTERS_KEY }
